import PropTypes from 'prop-types';
const IndexTableRowHoverCellSlot = ({
  children
}) => children;
IndexTableRowHoverCellSlot.propTypes = {
  children: PropTypes.any
};
IndexTableRowHoverCellSlot.displayName = 'IndexTableRowHoverCellSlot';
export default IndexTableRowHoverCellSlot;